module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "changeCity",
    on: {
      "click": _vm.changeCity
    }
  }, [_c('span', {
    attrs: {
      "id": "city"
    }
  }, [_vm._v(_vm._s(_vm.areaName))])]), _vm._v(" "), (_vm.isLogin) ? _c('div', {
    staticClass: "my58",
    attrs: {
      "onclick": "document.location.href='//m.m.58.com/index/'"
    }
  }) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "logo_a",
    attrs: {
      "href": "//m.58.com"
    }
  }, [_c('div', {
    staticClass: "logo"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a4a68f9","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/basic/components/nav/index.vue
// module id = 355
// module chunks = 0